
import React from 'react';
import { Container, Box, Typography, Grid, Avatar, ButtonBase } from '@mui/material';
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import YardIcon from '@mui/icons-material/Yard';
import CategoryIcon from '@mui/icons-material/Category';
import { motion } from 'framer-motion';

// A small helper to map string names to actual icon components
const iconMap = {
    EnergySavingsLeafIcon: <EnergySavingsLeafIcon />,
    YardIcon: <YardIcon />,
    CategoryIcon: <CategoryIcon />,
    LocalShippingIcon: <LocalShippingIcon />,
};

const defaultWhyUsFeatures = [
    { icon: 'EnergySavingsLeafIcon', title: 'Peak Freshness', description: 'Guaranteed farm-to-door freshness in every order.' },
    { icon: 'YardIcon', title: 'Local Sourcing', description: 'Partnering with local farms to support the community.' },
    { icon: 'CategoryIcon', title: 'Wide Selection', description: 'A diverse range of produce, dairy, and pantry staples.' },
    { icon: 'LocalShippingIcon', title: 'Reliable Delivery', description: 'On-time, refrigerated delivery you can count on.' },
];

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.3,
        },
    },
};

const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.8 } },
};

function WhyUsPage() {
    // Attempt to get features from env or fallback
    let whyUsFeatures = defaultWhyUsFeatures;
    try {
        if (process.env.REACT_APP_WHY_US_FEATURES) {
            whyUsFeatures = JSON.parse(process.env.REACT_APP_WHY_US_FEATURES);
        }
    } catch (e) {
        console.error("Failed to parse REACT_APP_WHY_US_FEATURES", e);
    }

    return (
        <Box sx={{ py: 8, bgcolor: 'background.default', minHeight: '80vh' }}>
            <Container maxWidth="lg">
                <motion.div initial="hidden" animate="visible" variants={containerVariants}>
                    <Box sx={{ bgcolor: '#75a84b', color: 'white', p: { xs: 3, sm: 4, md: 6 }, borderRadius: '16px', textAlign: 'center', boxShadow: '0 8px 24px -10px rgba(46,125,50,0.7)' }}>
                        <Typography variant="h3" component="h1" fontWeight={700} sx={{ mb: 2 }}>Why Shop With Us?</Typography>
                        <Typography variant="h6" component="p" sx={{ mb: 6, opacity: 0.9, maxWidth: '700px', mx: 'auto' }}>Your trusted wholesale produce partner for over 30 years.</Typography>
                        <Grid container spacing={3} justifyContent="center">
                            {whyUsFeatures.map((feature, index) => (
                                <Grid item xs={12} sm={6} md={3} key={index}>
                                    <motion.div variants={itemVariants} style={{ height: '100%' }}>
                                        <ButtonBase sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', p: 3, borderRadius: 2, textAlign: 'center', transition: 'background-color 0.2s ease-in-out', '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' } }}>
                                            <Avatar sx={{ bgcolor: 'rgba(255, 255, 255, 0.15)', width: 64, height: 64, mb: 2 }}>{iconMap[feature.icon]}</Avatar>
                                            <Typography variant="h6" component="p" fontWeight="bold" sx={{ mb: 1 }}>{feature.title}</Typography>
                                            <Typography variant="body1" sx={{ opacity: 0.8 }}>{feature.description}</Typography>
                                        </ButtonBase>
                                    </motion.div>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </motion.div>
            </Container>
        </Box>
    );
}

export default WhyUsPage;
